import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DeliveriesDelete, DeliveriesDelivered, DeliveriesPlanning, DeliveriesPlanningState, DeliveriesPublish, Delivery, DeliveryComment, DeliveryCommentUpsert, DeliveryCreate, DeliveryDriverValidate, DeliveryExportOptions, DeliveryRoadmap, DeliverySearchOptions, DeliverySplit, DeliveryUpdate, TankLevelUpsert } from 'src/swagger-gen/lng/models';
import { BaseService } from '../services/Base.service';
import {LogisticsService} from '../../swagger-gen/lng/services/logistics.service';
@Injectable({
  providedIn: 'root',
})
export class DeliveriesRepo extends BaseService {
    url = environment.apiUrl + '/deliveries' ;
    tankUrl = environment.apiUrl + '/tanks' ;
    readonly USERS_LIMIT = '25';

    constructor(private http: HttpClient, private readonly logisticsService: LogisticsService) {
      super();
    }


    /**
     * Get all deliveries
     */
    getDeliveriesList(params: HttpParams, body: DeliverySearchOptions ): Observable<any> {
      const url = this.url + '/search';

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        params: params,
      };
      
      const bodyReq = body ? body : {};
      return this.http.post<any>(url, bodyReq, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }
  
    /**
     * Get planning
     */
    getPlanning(params: HttpParams): Observable<DeliveriesPlanning> {
      const url = this.url + '/planning';

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        params: params,
      };
  
      return this.http.get<DeliveriesPlanning>(url, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    /**
     * Get planning
     */
      getRoadMap(params: HttpParams): Observable<DeliveryRoadmap[]> {
        const url = this.url + '/roadmap';
  
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          params: params,
        };
    
        return this.http.get<DeliveryRoadmap[]>(url, httpOptions).pipe(
          catchError(this.handleServerError)
        );
      }

    getPlanningState(): Observable<DeliveriesPlanningState> {
      const url = this.url + '/planning/state';

      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      };
  
      return this.http.get<DeliveriesPlanningState>(url, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    updateTankLevel(uidTank: string, level: TankLevelUpsert): Observable<any> {
      const url = `${this.tankUrl}/${uidTank}/level`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.post<any>(url, level, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    getDelivery(deliveryUid: string ):Observable<Delivery>  {
      const url = `${this.url}/${deliveryUid}`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.get<Delivery>(url, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    createDelivery(deliveryCreate: DeliveryCreate) {
      const url = `${this.url}`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.post<any>(url, deliveryCreate, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    updateDelivery(deliveryUid: string, deliveryUpdate: DeliveryUpdate) {
      const url = `${this.url}/${deliveryUid}`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.put<any>(url, deliveryUpdate, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    updateDeliveryPatch (params: LogisticsService.UpsertDeliveryPatchParams) {
        const url = `${this.url}/${params.uid}/patch`
        const {deliveryPatchUpsert} = params;

        const httpOptions = {
            headers: this.httpHeaders(),
        };

        return this.http.put<any>(url, deliveryPatchUpsert, httpOptions)
            .pipe(catchError(this.handleServerError)
        );

    }

    deleteDeliveryPatch(uid: string) {
        const url = `${this.url}/${uid}/patch`;

        const httpOptions = {
            headers: this.httpHeaders(),
            body: {}
        };

        return this.http.delete<any>(url, httpOptions)
            .pipe(catchError(this.handleServerError)
        );
    }

    deleteDelivery(deliveryUids: DeliveriesDelete ) {
      const url = `${this.url}`;

      const httpOptions = {
        headers: this.httpHeaders(),
        body: deliveryUids
      };
  
      return this.http.delete<any>(url, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    publishDeliveries(deliveryUids: DeliveriesPublish ) {
      const url = `${this.url}/publish`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.post<any>(url, deliveryUids, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    deliverDeliveries(deliveryUids: DeliveriesDelivered ) {
      const url = `${this.url}/deliver`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.post<any>(url, deliveryUids, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    getSplit(deliveryUid: string): Observable<DeliverySplit> {
      const url = `${this.url}/${deliveryUid}/split`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.get<DeliverySplit>(url, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    createSplit(deliveryUid: string, deliverySplit: DeliverySplit) {
      const url = `${this.url}/${deliveryUid}/split`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.post<any>(url, deliverySplit, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    exportDeliveries(params: HttpParams, body: DeliveryExportOptions): Observable<any> {
      const url = `${this.url}/export`;
  
      const httpOptions: any = {
        headers: this.httpHeaders(),
        responseType: 'blob' as 'json',
        observe: 'response',
        params: params,
      };

      const bodyReq = body ? body : {};
      return this.http.post<any>(url, bodyReq, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }


    deliveryDriverValidation(deliveryUid: string, body: DeliveryDriverValidate) {
      const url = `${this.url}/${deliveryUid}/validate`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };
  
      return this.http.post<any>(url, body, httpOptions).pipe(
        catchError(this.handleServerError)
      );
    }

    editDeliveryComment(deliveryUid: string, commentUid: string, body: DeliveryCommentUpsert): Observable<DeliveryComment>{
      const url = `${this.url}/${deliveryUid}/comments/${commentUid}`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };

      return this.http.put<DeliveryComment>(url, body, httpOptions).pipe(
        catchError(this.handleServerError)
      )
    }

    deleteDeliveryComment(deliveryUid: string, commentUid: string): Observable<void>{
      const url = `${this.url}/${deliveryUid}/comments/${commentUid}`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };

      return this.http.delete<void>(url, httpOptions).pipe(
        catchError(this.handleServerError)
      )
    }

    createDeliveryComment(deliveryUid: string, body: DeliveryCommentUpsert): Observable<DeliveryComment>{
      const url = `${this.url}/${deliveryUid}/comments`;

      const httpOptions = {
        headers: this.httpHeaders(),
      };

      return this.http.post<DeliveryComment>(url, body, httpOptions).pipe(
        catchError(this.handleServerError)
      )
    }
  
}
